module.exports = __webpack_public_path__ + "static/media/Galleria - Turquoise_DK Gold - DK Gold.dd627198.jpg";